import type { ExtensionDependency, ResolvedExtensionDependency } from '@peekops/peek-extensions-framework/Extension'
import ExtensionHandlerService from '@peekops/peek-extensions-framework/services/extensions/extension-handler'

export default class CustomerFlowsExtensionHandlerService extends ExtensionHandlerService {
  /**
   * defines how to import a local dependency, for local extensions
   * @param importObject
   */
  dynamicallyImportLocalDependency (importObject: ExtensionDependency): Promise<ResolvedExtensionDependency> {
    const { url } = importObject

    return new Promise((resolve, reject) => {
      import(`@spinnaker/iliad/dist/${url}.js`).then(module => {
        resolve({
          type: importObject.type,
          isMainScript: importObject.isMainScript ?? false,
          module
        })
      }).catch(error => {
        console.error('IMPORT ERROR', error)
        reject(error)
      })
    })
  }

  /**
   * defines how to import local web-components, for extensions that uses those
   * @param importObject
   */
  dynamicallyImportLocalWebComponents (importObject: ExtensionDependency): Promise<ResolvedExtensionDependency> {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      import('@spinnaker/iliad/dist/components.js').then(module => {
        resolve({
          type: importObject.type,
          isMainScript: importObject.isMainScript ?? false,
          // @ts-ignore
          module
        })
      }).catch(error => {
        console.error('IMPORT ERROR', error)
        reject(error)
      })
    })
  }
}
